export default defineNuxtPlugin((nuxtApp) => {
  if (!window.performance.meta) {
    window.performance.meta = {};
  }
  const path = window.location.pathname;
  const host = window.location.host;
  const pageName = document.title;
  const openWebTimeKey = "sys_open_web_time";
  const jsExecTime = window.performance.meta.jsExecTime;
  let openWebTime = -1;
  const originUrl = window.location.href;
  const originUrlObj = new URL(originUrl);
  const routineValue = originUrlObj.searchParams.get(openWebTimeKey);
  if (routineValue) {
    openWebTime = Number(routineValue);
  } else if (
    originUrlObj.hash.includes(openWebTimeKey) &&
    originUrlObj.hash.includes("?")
  ) {
    const searchStr = originUrlObj.hash.split("?")[1];
    const sp = new URLSearchParams(searchStr);
    openWebTime = Number(sp.get(openWebTimeKey) ?? -1);
  }
  if (openWebTime === -1) {
    openWebTime = parseInt(window.performance.timeOrigin + "");
  }

  window.performance.meta.showPageTime = openWebTime;

  pandora.send("event_web_time_origin", "-", {
    path,
    host,
    pagename: pageName,
    totaltime: getTimeDeal(window.performance.timeOrigin - openWebTime),
  });
  pandora.send("event_web_js_exec_time", "-", {
    path,
    host,
    pagename: pageName,
    totaltime: getTimeDeal((jsExecTime ?? 0) - openWebTime),
  });

  try {
    new PerformanceObserver((entryList) => {
      entryList.getEntries().forEach((item) => {
        if (item.name === "first-contentful-paint") {
          const loadingFinishTime = performance.timeOrigin + item.startTime;
          window.performance.meta.loadingFinishTime = loadingFinishTime;
          pandora.send("event_web_fcp_time", "-", {
            path,
            host,
            pagename: pageName,
            totaltime: getTimeDeal(
              performance.timeOrigin + item.startTime - openWebTime,
            ),
            deltatime: getTimeDeal(
              performance.timeOrigin + item.startTime - (jsExecTime ?? 0),
            ),
          });
        }
      });
    }).observe({ type: "paint", buffered: true });
  } catch (error) {
    console.error("performance.client error", error);
  }

  window.performance.metaFillFinish = function (args) {
    const currentTime = Date.now();
    pandora.send("event_web_fill_finish", "-", {
      path,
      host,
      pagename: pageName,
      totaltime: getTimeDeal(currentTime - openWebTime),
      deltatime: getTimeDeal(currentTime - (jsExecTime ?? 0)),
      ...args,
    });
  };
  window.performance.metaApiFinish = function (option, args) {
    pandora.send("event_web_api_finish", "-", {
      path,
      host,
      api_path: option.url,
      pagename: pageName,
      totaltime: getTimeDeal(option.endTime - option.startTime),
      deltatime: getTimeDeal(option.endTime - (jsExecTime ?? 0)),
      ...args,
    });
  };

  window.performance.metaMountedFinish = function (option, args) {
    pandora.send("event_web_mounted_finish", "-", {
      path,
      host,
      pagename: pageName,
      totaltime: getTimeDeal(option.endTime - option.startTime),
      deltatime: getTimeDeal(option.endTime - (jsExecTime ?? 0)),
      ...args,
    });
  };

  /**
   * 获取时间处理
   * @param {number} time time
   * @returns {void}
   */
  function getTimeDeal(time: number) {
    if (isNaN(time)) {
      return -1;
    }
    if (openWebTime === -1) {
      return -1;
    }
    return time;
  }
});
